import { IconButton } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import { Alert, Button, Checkbox, Modal, Timeline, Upload, Row, Col, Typography } from 'antd';
import Axios from 'axios';
import { debounce, get, set } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import projectModalImage from '../../../../../../../assets/img/project-modal.jpg';
import { ApiConstant } from '../../../../../../constants';
import { getGCSUrl } from '../../../../../../services/Common';
import { pushLog2DV2LogServer } from '../../../../../../services/logging';
import { CaretUpEmberIcon, HeaderErrorIcon, GreenCheckMark, RedCancelIcon } from '../../../../../components/common/CustomIcon';
import { CONTENT_IDS } from '../../../../../constants';
import { getVettedSkillsStats, getWorkHistoriesStats } from '../../../../../util/profileCheckUtil';
import { Input } from '../../../../shared';

import CustomModal from '../../../../shared/CustomModal/CustomModal';
import RightSidebar from '../../../../../../components/RightSidebar';
import SelectCustomSkills from '../../../../shared/SkillSelect/SkillSelect';

class Workhistory extends Component {
  state = {
    dataSource: [],
    hasSkillError: false,
    hasError: false,
    insufficientSkills: [],
    totalDetails: 0,
    showWarning: false,
    currentSkill: null,
    showFinalWarningModal: false,
    skillsResult: [],
    overrideCheck: false
  };

  constructor (props) {
    super(props);
    this.dataSourceChangeDebounce = debounce(this.dataSourceChange, 500);
  }

  setDataSource = (dataSource) => {
    this.setState({ dataSource: dataSource.map(this.initItem) }, () => {
      if (!this.state.dataSource.length) {
        this.addNewWorkhistoryItem();
      }
      this.dataSourceChangeDebounce();
      this.initialise();
    });
  }

  componentDidUpdate () {
    if (this.props._ref) {
      this.props._ref.current = this;
    }
  }

  validateSkillsDetails = () => {
    const { passed_skills, skills } = this.props;
    const { dataSource } = this.state;
    const completedSkillsInt = (passed_skills || []).map((skill) => parseInt(skill, 10));
    const vettedSkills = (skills || []).filter(skill => completedSkillsInt.indexOf(parseInt(skill.skill_id, 10)) > -1);
    let skippedSkill = localStorage.getItem('skippedSkillId');
    if (skippedSkill) {
      skippedSkill = JSON.parse(skippedSkill);
    }
    const { vettedSkillsStats } = getVettedSkillsStats(vettedSkills, dataSource);
    const inSufficientSkillDetails = vettedSkillsStats.filter(vSkill => (vSkill.skillMentionsCount < 3 || vSkill.skillYOE < 2))
      .map(item => {
        if (skippedSkill && Array.isArray(skippedSkill)) {
          if (skippedSkill.indexOf(parseFloat(item.skill.skill_id)) >= 0) {
            item.noExp = true;
          } else item.noExp = false;
        } else item.noExp = false;
        return item;
      });
    const totalDetails = getWorkHistoriesStats(dataSource);
    return { skillInsufficientDetail: inSufficientSkillDetails, totalDetails };
  }

  initialise = () => {
    const { skillInsufficientDetail, totalDetails } = this.validateSkillsDetails();
    this.setState({ insufficientSkills: skillInsufficientDetail, totalDetails });
  }

  validateSkillBeforeSubmit = () => {
    const { overrideCheck } = this.state;
    if (!overrideCheck) {
      const { skillInsufficientDetail, totalDetails } = this.validateSkillsDetails();
      let noError = true;
      if ((Array.isArray(skillInsufficientDetail) && skillInsufficientDetail.length > 0) || totalDetails < 500) {
        noError = false;
      };
      this.setState({ totalDetails, skillsResult: skillInsufficientDetail });
      return noError;
    }
    return true;
  }

  /** Get the overall count of work experience details in words */
  sumDetails = () => {
    const { dataSource } = this.props;
    const sum = getWorkHistoriesStats(dataSource);
    return sum;
  }

  dataSourceChange = () => {
    const { onDataSourceChange } = this.props;
    // filter to not save binary file in storge
    const data = this.state.dataSource.map(refItem => {
      const item = Object.assign({}, refItem);
      item.projects = Array.isArray(item.projects)
        ? item.projects.map(project => {
          return { ...project, files: project.files.filter(file => !file.originFileObj) };
        })
        : [];
      return item;
    });
    if (onDataSourceChange) onDataSourceChange(data);
  }

  onClickNext = () => {
    return Promise.all([
      ...this.state.dataSource.map(item => item.save()),
      // this.topSkillsInProjectValidation(),
      this.validateSkillBeforeSubmit()
    ])
      .then(results => {
        if ((results.indexOf(false) >= results.length - 1) && !results[results.length - 1]) {
          this.setState({ showFinalWarningModal: true });
        }
        return !results.includes(false);
      })
      .catch(console.error);
  }

  topSkillsInProjectValidation = () => {
    const { skills } = this.props;
    const { dataSource } = this.state;
    const valid = !skills
      .filter(skill => skill.passed)
      .map(skill => {
        const found = dataSource.find(item => item.projects.find(project => project.skills.find(s => s.skill_id === skill.skill_id)));
        return !!found;
      })
      .includes(false);
    this.setState({ hasSkillError: !valid });
    return Promise.resolve(valid);
  }

  addNewWorkhistoryItem = () => {
    const { dataSource } = this.state;
    dataSource.push(this.initItem({ projects: [], $changed: (new Date()).getTime() }));
    this.setState({ dataSource });
  };

  initItem = (item) => {
    if (!item) item = { projects: [] };
    item.set = (data = {}, isChange = true) => {
      const { dataSource } = this.state;
      if (isChange) {
        Object.assign(item, data, { $changed: (new Date()).getTime() });
      } else {
        Object.assign(item, data);
      }
      this.setState({ dataSource }, this.dataSourceChangeDebounce);
    };

    item.sumDetails = () => {
      const totalDetails = this.sumDetails();
      this.setState({ totalDetails });
    };

    item.bind = (name) => {
      let value = get(item, name, '');
      if (value === 'null') value = '';
      return {
        value,
        onChange: (e) => {
          let value = e;
          if (e && typeof e === 'object' && 'target' in e) {
            value = e.target.value;
          }
          set(item, name, value);
          set(item, 'errors.' + name, null);
          item.set();
          item.validation(true);
          this.setState({ hasError: false });
        },
        onBlur: () => {
          item.validation(true, name);
        },
        ...get(item, 'errors.' + name, null)
      };
    };

    item.validateAfterProjectAdded = () => {
      let valid = true;
      const errors = {};
      if (!item.position &&
        !item.company &&
        !item.start_month &&
        !item.start_year && !item.end_month &&
        !item.end_year) {
        errors.company = { validateStatus: 'error' };
        errors.position = { validateStatus: 'error' };
        errors.start_month = { validateStatus: 'error' };
        errors.start_year = { validateStatus: 'error' };
        errors.end_month = { validateStatus: 'error' };
        errors.end_year = { validateStatus: 'error' };
        valid = false;
        item.set({ errors }, !valid);
        this.setState({ hasError: !valid });
      }
      return valid;
    };

    item.validation = (updateErrorState, name = null, isSubmit = false) => {
      let valid = true;
      const errors = {};
      if (
        !name &&
        !item.position &&
        !item.company &&
        !item.start_month &&
        !item.start_year
      ) {
        if (updateErrorState) {
          item.set({ errors }, !valid);
          this.setState({ hasError: !valid });
        }
        return valid;
      }

      if ((name === 'position' || isSubmit) && !item.position) {
        errors.position = { validateStatus: 'error' };
        valid = false;
      }

      if ((name === 'company' || isSubmit) && !item.company) {
        errors.company = { validateStatus: 'error' };
        valid = false;
      }

      if (isSubmit && !item.start_month) {
        errors.start_month = { validateStatus: 'error' };
        valid = false;
      }

      if (isSubmit && !item.start_year) {
        errors.start_year = { validateStatus: 'error' };
        valid = false;
      }

      if (item.end_year !== 0) {
        if (isSubmit && !item.end_month) {
          errors.end_month = { validateStatus: 'error' };
          valid = false;
        }

        if (isSubmit && !item.end_year) {
          errors.end_year = { validateStatus: 'error' };
          valid = false;
        }

        if (item.start_month && item.start_year && item.end_year && item.end_month) {
          const getDate = (start_end) => {
            const month = item[`${start_end}_month`];
            const year = item[`${start_end}_year`];
            if (month && year) return moment(`${year}-${month}`, 'YYYY-MMMM');
            return null;
          };
          const start_date = getDate('start');
          const end_date = getDate('end');
          if (moment(start_date.format('YYYY-MM-01')).isAfter(end_date.format('YYYY-MM-01'))) {
            errors.start_month = { validateStatus: 'error' };
            errors.start_year = { validateStatus: 'error' };
            errors.end_year = { validateStatus: 'error' };
            errors.end_month = { validateStatus: 'error' };
            valid = false;
          }
        }
      }

      // if (!item.details) {
      //   errors.details = { validateStatus: 'error' };
      //   valid = false;
      // }
      if (updateErrorState) {
        item.set({ errors }, !valid);
        this.setState({ hasError: !valid });
      }
      return valid;
    };

    item.delete = () => {
      Modal.confirm({
        title: <h1 className="Delete-work-experience">Delete work experience?</h1>,
        content: 'This action cannot be undone.',
        okText: 'Yes, delete',
        okType: 'danger',
        cancelText: 'Cancel',
        iconType: null,
        width: 400,
        onOk: () => {
          if (!item.id) {
            const { dataSource } = this.state;
            this.setState({ dataSource: dataSource.filter(elm => elm !== item) });
            return;
          }
          const token = localStorage.getItem('token');
          const headers = {
            'Content-Type': 'application/json',
            Authorization: token
          };
          pushLog2DV2LogServer.info('ONBOARDING', 'DELETE_WORKHISTORY', {}, {}, null);
          return Axios
            .delete(`${ApiConstant.BASE_URL}onboarding/delete-workhistory/${item.id}`, {}, { headers })
            .then(result => {
              const { dataSource } = this.state;
              this.setState({ dataSource: dataSource.filter(elm => elm !== item) }, this.dataSourceChangeDebounce);
            })
            .catch(error => {
              const { message, stack, code } = error;
              pushLog2DV2LogServer.error('ONBOARDING', 'DELETE_WORKHISTORY', {}, {}, { message, stack, code });
              console.error(error);
            });
        }
      });
    };

    item.save = () => {
      if (!item.validation(true, null, true)) return Promise.resolve(false);
      if (!item.$changed) return Promise.resolve(true);
      /** Only check if company or any key is not empty in
       * Experience field since it will trigger error if validation is false in first instance
       * This prevent API call and deleting of project when Work experience data is absent
       */
      if (!item.validateAfterProjectAdded()) {
        return Promise.resolve(false);
      }
      const dataForm = new FormData();
      const projects = item.projects.map((project, i) => {
        const files = project.files.map((file, j) => {
          if (file.originFileObj) {
            dataForm.append(`file_${i}_${j}`, file.originFileObj);
            return { fileId: `file_${i}_${j}` };
          }
          return file;
        }).filter(file => file.fileId);
        return {
          ...project,
          files,
          deletedFiles: project.deletedFiles || []
        };
      });

      const formatProject = project => {
        return {
          id: project.id,
          project_name: project.project_name,
          url: project.url,
          details: project.details,
          outcome: project.outcome,
          skills: (project.skills || []).map(skill => skill.skill_id),
          files: project.files,
          start_month: project.start_month,
          start_year: project.start_year,
          end_month: project.end_month,
          end_year: project.end_year,
          deletedFiles: project.deletedFiles || []
        };
      };

      const insertProjects = projects.filter(project => project.newProject).map(formatProject);
      const updateProjects = projects.filter(project => project.$changed && !project.newProject && !project.$deleted).map(formatProject);
      const deleteProjects = projects.filter(project => project.$deleted && project.id).map(project => project.id);

      dataForm.append('data', JSON.stringify({ ...item, projects: [], insertProjects, updateProjects, deleteProjects }));
      const token = localStorage.getItem('token');
      const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: token
      };
      const endPoint = item.id ? `onboarding/edit-workhistory/${item.id}` : 'onboarding/save-workhistory';
      pushLog2DV2LogServer.info('ONBOARDING', 'SAVE_WORKHISTORY', {}, {}, null);
      return Axios
        .post(`${ApiConstant.BASE_URL}${endPoint}`, dataForm, { headers })
        .then(result => result.data)
        .then(data => {
          const { dataSource } = this.state;
          if (data.success) {
            data.item.projects.map(project => {
              const p = projects.filter(pp => !pp.$deleted).find(pp => (pp.id && pp.id === project.id) || (pp.newProject && pp.project_name === project.project_name));
              if (p) {
                const skillsInfos = p.skills.reduce((acc, skill) => {
                  if (skill.autoSelect) {
                    acc.autoTaggingSkills.push({
                      skill: skill.skill_name,
                      id: skill.skill_id
                    });
                  } else {
                    acc.manualAddingSkills.push({
                      skill: skill.skill_name,
                      id: skill.skill_id
                    });
                  }
                  return acc;
                }, { autoTaggingSkills: [], manualAddingSkills: [] });
                pushLog2DV2LogServer.info(
                  'AUTO_TAGGING_SKILLS',
                  'AUTO_TAGGING_SKILLS',
                  {},
                  { user_id: project.developer_id, project_id: project.id, ...skillsInfos },
                  {}
                );
              }
            });
          }
          this.setState({ dataSource: dataSource.map(elm => elm === item ? this.initItem(data.item) : elm) }, this.dataSourceChangeDebounce);
          this.initialise();
          return true;
        })
        .catch(error => {
          const { message, stack, code } = error;
          pushLog2DV2LogServer.error('ONBOARDING', 'SAVE_WORKHISTORY', {}, {}, { message, stack, code });
          console.error(error);
        });
    };
    return item;
  }

  renderTopSkills = () => {
    const { skills } = this.props;
    const { dataSource, helpModal, hasSkillError } = this.state;
    if (!Array.isArray(skills)) return null;
    return (
      <>
        {hasSkillError ? <Alert message="Include at least 1 project for each of your skills." type="error" /> : null}
        <div className="top-skills-container">
          <div className="top-skills">
            {skills.filter(skill => skill.passed).map(skill => {
              const GCSIcon = skill.icon ? `${getGCSUrl()}/icon/${skill.icon}` : '/images/no-image.png';
              const found = dataSource.find(item => item.projects.find(project => project.skills.find(s => s.skill_id === skill.skill_id)));
              return (
                <div className={`top-skill ${found ? '' : 'notfound has-error'}`} key={skill.skill_id}>
                  <img src={GCSIcon} className="top-skill-icon" /> <span>{skill.skill_name}</span> { found ? <CheckCircleIcon style={{ color: '#66CC80' }} /> : null }
                </div>
              );
            })}
          </div>
          <span onClick={() => this.setState({ helpModal: true })}><HelpOutlineIcon/> Where do I add skills?</span>
          <Modal visible={helpModal} footer={null} onCancel={() => this.setState({ helpModal: false })}>
            <div className="help-modal">
              <h1>Where do I add skills?</h1>
              <p>You can add skills to a project by selecting them in the <br/><b>Technologies and tools used</b> field as shown below.</p>
              <img src={projectModalImage} alt="project modal" />
              <div>
                <Button type="primary" onClick={() => this.setState({ helpModal: false })}>Got it</Button>
              </div>
            </div>
          </Modal>
        </div>
      </>
    );
  }

  renderWorkExpWarning = () => {
    const { insufficientSkills, totalDetails, currentSkill, showWarning } = this.state;
    if ((Array.isArray(insufficientSkills) && insufficientSkills.length > 0) || totalDetails < 500) {
      return (
        <>
          <Row style={{ marginBottom: '40px' }}>
            <Typography.Text className='warning-description'>
              Complete the following requirements to double your chances of getting matched:
            </Typography.Text>
          </Row>
          <div style={{ marginBottom: '24px' }}>
            {
              this.renderDetailsWarning()
            }
            {
              insufficientSkills.length > 0
                ? (
                  this.renderSkillsWarning(insufficientSkills)
                )
                : null
            }
          </div>
          <Modal wrapClassName='confirm-modal' width="500px" visible={showWarning} okText="Confirm" onOk={this.onWarningConfirm} onCancel={() => this.setState({ showWarning: false, currentSkill: null })}>
            {currentSkill
              ? (
                <Row>
                  <Col style={{ marginBottom: '32px' }}>
                    <Typography.Text className='confirm-title'>No experience in {currentSkill.skill_name}</Typography.Text>
                  </Col>
                  <Col style={{ marginBottom: '8px' }}>
                    <Typography.Text className='confirm-description'>We can&apos;t match you for this skill if you don&apos;t have enough experience in your profile.</Typography.Text>
                  </Col>
                </Row>
              )
              : null}
          </Modal>
        </>
      );
    }
    return null;
  }

  renderSkillsWarning = (data = [], showBtn = true) => {
    if (data.length > 0) {
      return (
        <div>
          {
            data.map(skill => (
              <div style={{ marginBottom: '32px' }} key={skill.skill_id}>
                <Row>
                  <Col span={showBtn ? 1 : 2}>
                    {skill.noExp ? <RedCancelIcon /> : <CaretUpEmberIcon /> }
                  </Col>
                  <Col offset={1}><Typography.Text className='warning-title'>{!skill.noExp ? `Add enough experience for ${skill.skill_name}` : `Not enough experience for ${skill.skill_name}`}</Typography.Text></Col>
                </Row>
                {!skill.noExp
                  ? (
                    <Row type="flex" justify="space-between" align="top">
                      <Col offset={showBtn ? 1 : 2}>
                        <Typography.Text className='warning-text'>
                        Mention this skill at least 3 times in Project detail.
                        </Typography.Text>
                        <br/>
                        <Typography.Text className='warning-text'>
                        Need to have at least 2 years of exp.
                        </Typography.Text>
                      </Col>
                      {
                        showBtn
                          ? (
                            <Col className='confirm-btn-col'>
                              <Button onClick={() => this.setState({ showWarning: true, currentSkill: skill })}>I don&apos;t have enough exp.</Button>
                            </Col>
                          )
                          : null
                      }
                    </Row>
                  )
                  : (
                    <Row type='flex'>
                      <Col offset={1}>
                        <Typography.Text className='warning-text'>
                          We can&apos;t match you for this skill because you don&apos;t have enough experience in your profile. <a onClick={() => this.onHasSkills(skill)} style={{ color: '#666666', textDecoration: 'underline' }}>I have enough experience</a>
                        </Typography.Text>
                      </Col>
                    </Row>
                  )}
              </div>
            ))
          }
        </div>
      );
    } return null;
  }

  renderDetailsWarning = (final = false) => {
    const { totalDetails } = this.state;
    return (
      <div style={{ marginBottom: '32px' }}>
        <Row>
          <Col span={final ? 2 : 1}>
            {totalDetails < 500 ? <CaretUpEmberIcon /> : <GreenCheckMark />}
          </Col>
          <Col offset={1}>
            <Typography.Text className='warning-title'>{totalDetails < 500 ? 'Add at least 500 words in the Work history section' : 'Added at least 500 words in the Work History section.'}</Typography.Text>
          </Col>
        </Row>
        <Row>
          <Col offset={final ? 2 : 1}>
            <Typography.Text className='warning-text'>Current: {totalDetails} / 500 words</Typography.Text>
          </Col>
        </Row>
      </div>
    );
  }

  renderFinalModal = () => {
    const { showFinalWarningModal, skillsResult, totalDetails } = this.state;
    return (
      <Modal wrapClassName='confirm-final-modal' width="500px" visible={showFinalWarningModal} okText="Submit anyway" onOk={this.onSubmitAnyway} onCancel={this.onCancelFinalWarning}>
        <Row style={{ marginBottom: '8px' }}>
          <Typography.Text className="confirm-modal-description">Before you submit your resume</Typography.Text>
        </Row>
        <Row style={{ marginBottom: '40px' }}>
          <Typography.Text className="confirm-modal-heading">
          Double your chances of getting matched
          </Typography.Text>
        </Row>
        { totalDetails < 500 ? this.renderDetailsWarning(true) : null }
        {Array.isArray(skillsResult) && skillsResult.length > 0 ? this.renderSkillsWarning(skillsResult, false) : null}
      </Modal>
    );
  }

  onCancelFinalWarning = () => {
    this.setState({ showFinalWarningModal: false }, () => {
      const weField = document.querySelector('.flex-start');
      if (weField) weField.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
    });
  }

  onHasSkills = (skill) => {
    this.setState({ currentSkill: skill }, this.onWarningConfirm);
  }

  onSubmitAnyway = () => {
    const { submitProps } = this.props;
    this.setState({ showFinalWarningModal: false, overrideCheck: true }, () => {
      if (submitProps && submitProps.submit) {
        submitProps.submit();
        setTimeout(() => {
          this.setState({ overrideCheck: false });
        }, 500);
      }
    });
  }

  onWarningConfirm = () => {
    const { currentSkill, insufficientSkills } = this.state;
    const copySkills = insufficientSkills;
    const skillIndex = copySkills.findIndex(item => item.skill.skill_id === currentSkill.skill.skill_id);
    if (skillIndex >= 0) {
      copySkills[skillIndex].noExp = !copySkills[skillIndex].noExp;
      const skippedSkill = localStorage.getItem('skippedSkillId');
      let skippedSkillArray = [];
      // Save skipped skill to localstorage
      if (copySkills[skillIndex].noExp) {
        if (skippedSkill) {
          skippedSkillArray = JSON.parse(skippedSkill);
          skippedSkillArray.push(currentSkill.skill.skill_id);
          // console.log(skippedSkillArray)
        } else {
          skippedSkillArray = [parseFloat(currentSkill.skill.skill_id)];
        }
      } else {
        if (skippedSkill) {
          skippedSkillArray = JSON.parse(skippedSkill);
          skippedSkillArray = skippedSkillArray.filter(skill_id => parseFloat(skill_id) !== parseFloat(currentSkill.skill.skill_id));
        }
      }
      localStorage.setItem('skippedSkillId', JSON.stringify(skippedSkillArray));
      this.setState({ insufficientSkills: copySkills, showWarning: false, currentSkill: null });
    }
  }

  render () {
    const { dataSource, hasError } = this.state;
    const { skills, base_skills, passed_skills, skills_inprogress } = this.props;
    return (
      <div>
        <div className="flex-start">
          <h2 className={ hasError ? 'has-error' : '' }><span>What&apos;s your work history?</span> </h2>
          {hasError ? (<div className="warning-message"><WarningRoundedIcon/> <span>Required</span></div>) : null}
        </div>
        {/* <p>Top US companies on Turing&apos;s platform will hire you based on your contributions to past technical projects. Include at least 1 project for each of your skills.</p> */}
        {/* { this.renderTopSkills() } */}
        { this.renderWorkExpWarning() }
        { this.renderFinalModal() }
        <Timeline>
          {dataSource.map((item, i) => (
            <Timeline.Item key={i} color="black">
              <WorkhistoryItem passed_skills={passed_skills} skills_inprogress={skills_inprogress} base_skills={base_skills} render={item.$changed} setContentId={this.props.setContentId} item={item} skills={skills} />
              <hr />
            </Timeline.Item>
          ))}
          <Timeline.Item color="black">
            <Button onClick={this.addNewWorkhistoryItem}>
              <AddIcon /> Add experience
            </Button>
          </Timeline.Item>
        </Timeline>
      </div>
    );
  }
}

Workhistory.propTypes = {
  dataSource: PropTypes.array,
  skills: PropTypes.array,
  base_skills: PropTypes.array,
  passed_skills: PropTypes.array,
  skills_inprogress: PropTypes.array,
  progress: PropTypes.func,
  setContentId: PropTypes.func,
  onDataSourceChange: PropTypes.func,
  _ref: PropTypes.any,
  submitProps: PropTypes.object
};

class WorkhistoryItem extends React.PureComponent {
  years = [];
  months = [];

  constructor (props) {
    super(props);
    this.projects = React.createRef();
    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ];
    this.years = [];
    for (let i = 0; i <= 35; i++) {
      this.years.push({
        value: new Date().getFullYear() - i,
        label: new Date().getFullYear() - i
      });
    }
    this.months = months.map((month) => ({ value: month, label: month }));
  }

  onProjectsUpdate = (projects) => {
    const { item } = this.props;
    item.set({ projects });
  }

  setContentId = id => {
    const { setContentId } = this.props;
    if (setContentId) setContentId(id);
  }

  saveDetails = id => {
    const { item } = this.props;
    this.setContentId(id);
    if (item && item.sumDetails) item.sumDetails();
  }

  getErrorMessage = (errors, name) => {
    const { item } = this.props;
    if (!errors) return null;
    if (item.start_month && item.start_year && item.end_month && item.end_year) {
      if (('start_month' in errors) && ('start_year' in errors) &&
      ('end_month' in errors) && ('end_year' in errors)) { return 'End date should be greater than start date'; }
    }

    // if ('position' in errors) return 'Work position is missing';
    // if ('company' in errors) return 'Company name is missing';
    // if ('start_month' in errors) return 'Start month is missing';
    // if ('start_year' in errors) return 'Start year is missing';
    // if ('end_year' in errors) return 'End year is missing';
    // if ('end_month' in errors) return 'End month is missing';

    return null;
  }

  render () {
    const { item, skills, base_skills, passed_skills, skills_inprogress } = this.props;
    if (!item) return null;
    const title = !item.position && !item.company ? 'Work history' : `${item.position ? item.position : ''} ${item.position && item.company ? '-' : ''} ${item.company ? item.company : ''}`.trim();
    const gotError = item.errors && Object.keys(item.errors).length;
    const errorMessage = this.getErrorMessage(item.errors);

    return (
      <div>
        <div className={`Workhistory-title ${gotError ? 'title-error' : ''}`}>
          <span>
            {title}
            { gotError
              ? (
                <div className='title-error-message'>
                  <HeaderErrorIcon />
                  {errorMessage}
                </div>
              )
              : null}
          </span>
          <IconButton onClick={item.delete}>
            <DeleteIcon />
          </IconButton>
        </div>
        <div className="Workhistory-form">
          <div className="a">
            <Input placeholder="Position" {...item.bind('position')} />
          </div>
          <div className="b">
            <Input placeholder="Company" {...item.bind('company')} />
          </div>
          <div className="c">
            <Input.Select
              placeholder="Start month"
              options={this.months}
              {...item.bind('start_month')}
            />
          </div>
          <div className="d">
            <Input.Select
              placeholder="Start year"
              options={this.years}
              {...item.bind('start_year')}
            />
          </div>
          <div className="e">
            {item.end_year === 0
              ? null
              : (
                <Input.Select
                  placeholder="End month"
                  options={this.months}
                  {...item.bind('end_month')}
                />
              )}
          </div>
          <div className="f">
            {item.end_year === 0
              ? null
              : (
                <Input.Select
                  placeholder="End year"
                  options={this.years}
                  {...item.bind('end_year')}
                />
              )}
          </div>
          <div className="g">
            <Checkbox
              checked={item.end_year === 0}
              onChange={(e) =>
                item.set({
                  end_year: e.target.checked ? 0 : new Date().getFullYear()
                })
              }
            >
              Still working here
            </Checkbox>
          </div>
          <div className="h">
            <CustomModal.Highlight help={<RightSidebar.RoleComponent/>} onMobileShowButton="Show examples">
              <Input.TextArea
                placeholder="What was your role at the company?"
                rows={5}
                {...item.bind('details')}
                onFocus={() => this.setContentId(CONTENT_IDS.helpRole)}
                onBlur={() => this.saveDetails(CONTENT_IDS.experience)}
              />
            </CustomModal.Highlight>
          </div>
        </div>
        <div>
          <div className="Workhistory-form-project-title">
            <b>Projects</b>
            {(item.projects || []).filter(project => !project.$deleted).length
              ? (
                <Button
                  onClick={() => this.projects.current.addNewProject()}
                  icon="plus"
                  type="link"
                >
                Add project
                </Button>
              )
              : null}
          </div>
          <Projects
            ref={this.projects}
            item={item}
            skills={skills}
            base_skills={base_skills}
            passed_skills={passed_skills}
            skills_inprogress={skills_inprogress}
            onUpdate={this.onProjectsUpdate}
            setContentId={this.setContentId}
          />
        </div>
      </div>
    );
  }
}

WorkhistoryItem.propTypes = {
  item: PropTypes.any,
  skills: PropTypes.array,
  base_skills: PropTypes.array,
  passed_skills: PropTypes.array,
  skills_inprogress: PropTypes.array,
  setContentId: PropTypes.func
};

const Projects = React.memo(React.forwardRef((props, ref) => {
  class ProjectsList extends React.PureComponent {
    years = [];
    months = [];
    state = {
      activeProject: null,
      errors: {},
      skills: [],
      skillsListKey: 'skillsListKey',
      base_skills: []
    };

    constructor (props) {
      super(props);
      this.initProjectsRef();
      const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ];
      this.years = [];
      for (let i = 0; i <= 35; i++) {
        this.years.push({
          value: new Date().getFullYear() - i,
          label: new Date().getFullYear() - i
        });
      }
      this.months = months.map((month) => ({ value: month, label: month }));
      this.extractSkillsFromTextDebounce = debounce(this.extractSkillsFromText, 500);
    }

    componentDidUpdate (prevProps) {
      if (prevProps.item !== this.props.item) {
        this.initProjectsRef();
      }
    }

    componentDidMount () {
      this.initialize();
    }

    initialize = () => {
      const { skills, base_skills } = this.props;
      this.setState({ skills, base_skills: [...base_skills].map(skill => ({ ...skill, skill_id: +skill.id })) });
    }

    onSelect = (value) => {
      const { skills } = this.state;
      const mappedSkills = skills.map(skill => {
        if (parseInt(skill.skill_id, 10) === parseInt(value)) {
          skill.selected = true;
        }
        delete skill.autoSelect;
        return skill;
      }).filter(skill => skill.selected);
      this.setState({ skills: mappedSkills });
    }

    initProjectsRef = () => {
      ref.current = ref.current || {};
      ref.current.addNewProject = () => {
        this.setActiveProject({ $newProject: true, skills: [], files: [] });
      };
    }

    setActiveProject = refActiveProject => {
      if (refActiveProject) {
        this.setState({ errors: {}, activeProject: Object.assign({}, refActiveProject), refActiveProject });
      } else {
        this.setState({ activeProject: null, refActiveProject: null });
      }
    }

    onSave = () => {
      if (!this.validation(true)) return;
      const { item } = this.props;
      const { activeProject, refActiveProject } = this.state;
      if (activeProject && activeProject.$newProject) {
        delete activeProject.$newProject;
        activeProject.newProject = true;
        item.projects.push(activeProject);
      } else if (refActiveProject && activeProject) {
        Object.assign(refActiveProject, activeProject);
      }
      item.set();
      this.setActiveProject(null);
      setTimeout(() => item.save(), 100);
    };

    onDelete = () => {
      const { item } = this.props;
      const { refActiveProject } = this.state;
      refActiveProject.$deleted = true;
      item.set();
      this.setActiveProject(null);
    };

    set = (obj = {}) => {
      this.setState({ activeProject: Object.assign(this.state.activeProject, obj, { $changed: true }) });
    };

    bind = (name) => {
      const { activeProject } = this.state;
      if (!activeProject) return null;
      let value = get(activeProject, name, '');
      if (value === 'null') value = '';
      return {
        value,
        onChange: (e) => {
          let value = e;
          if (e && typeof e === 'object' && 'target' in e) {
            value = e.target.value;
          }
          if (value !== get(activeProject, name, '')) {
            set(activeProject, name, value);
            activeProject.$changed = true;
            this.setState({ activeProject, d: {} });
            this.resetError(name);
            if (name === 'details') {
              this.extractSkillsFromTextDebounce(value);
            }
          }
        },
        ...this.state.errors[name]
      };
    };

    extractSkillsFromText = (text) => {
      const { skills, base_skills, activeProject } = this.state;
      if (typeof text !== 'string' || !Array.isArray(base_skills)) return;
      if (text === '<br>') text = '';
      const skillsSelectedByUser = activeProject.skills.filter(item => !item.autoSelect);
      const textSkillsSelectedByUser = skillsSelectedByUser.map(skill => skill.skill_name).join(' ');
      text = text.trim().toLowerCase();
      const selectedList = base_skills
        .filter(item => !skillsSelectedByUser.find(elm => elm.skill_id === item.skill_id))
        .map(item => {
          item.skills = item.skill_name
            .split(/[/|,]/)
            .map(name => name.toLowerCase().trim())
            .filter(name => name)
            // eslint-disable-next-line no-useless-escape
            .map(name => name.replace(/([^a-zA-Z0-9\.\s\-])/g, '\\$1'))
            // eslint-disable-next-line no-useless-escape
            .map(name => name.replace(/([\.\s\-])/g, '[\\.\\s\\-]*?'))
            .map(name => new RegExp('\\b' + name + '\\b'));
          return item;
        })
        .filter(item => item.skills.every(name => {
          try {
            return text.match(name) || (textSkillsSelectedByUser.match(name) && item.skills.some(skill => !textSkillsSelectedByUser.match(skill)));
          } catch (e) {
            return false;
          }
        }))
        .map(item => {
          item.autoSelect = true;
          return item;
        });
      activeProject.skills = [...skillsSelectedByUser, ...selectedList];
      let newSkillsList = activeProject.skills.filter(item => !skills.find(elm => elm.skill_id === item.skill_id));
      newSkillsList = [...skills, ...newSkillsList];
      newSkillsList = newSkillsList.map(item => ({ ...item, autoSelect: false }));
      this.setState({ skills: newSkillsList, skillsListKey: `skillsListKey-${(new Date()).getTime()}`, activeProject });
    }

    setError = (name, help = '') => {
      const { errors } = this.state;
      errors[name] = { validateStatus: 'error', help };
      this.setState({ errors: { ...errors } });
    }

    resetError = (name = null) => {
      if (name) {
        const { errors } = this.state;
        errors[name] = null;
        this.setState({ errors: { ...errors } });
      } else {
        this.setState({ errors: { } });
      }
    }

    validation = (updateErrorState) => {
      const { activeProject } = this.state;
      let valid = true;

      if (!activeProject.project_name) {
        if (updateErrorState) this.setError('project_name');
        valid = false;
      } else {
        if (updateErrorState) this.resetError('project_name');
      }

      if (!activeProject.details || typeof activeProject.details !== 'string') {
        if (updateErrorState) this.setError('details');
        valid = false;
      } else if (activeProject.details.length < 300) {
        if (updateErrorState) this.setError('details', 'Please enter at least 300 characters');
        valid = false;
      } else if (activeProject.details.length > 65535) {
        if (updateErrorState) this.setError('details', 'Maximum 65,535 characters');
        valid = false;
      } else {
        if (updateErrorState) this.resetError('details');
      }

      if (!activeProject.outcome) {
        if (updateErrorState) this.setError('outcome');
        valid = false;
      } else {
        if (updateErrorState) this.resetError('outcome');
      }

      if (!activeProject.start_month) {
        if (updateErrorState) this.setError('start_month');
        valid = false;
      } else {
        if (updateErrorState) this.resetError('start_month');
      }

      if (!activeProject.start_year) {
        if (updateErrorState) this.setError('start_year');
        valid = false;
      } else {
        if (updateErrorState) this.resetError('start_year');
      }

      if (!activeProject.end_month) {
        if (updateErrorState) this.setError('end_month');
        valid = false;
      } else {
        if (updateErrorState) this.resetError('end_month');
      }

      if (!activeProject.end_year) {
        if (updateErrorState) this.setError('end_year');
        valid = false;
      } else {
        if (updateErrorState) this.resetError('end_year');
      }

      if (activeProject.start_month && activeProject.start_year && activeProject.end_year && activeProject.end_month) {
        const getDate = (start_end) => {
          const month = activeProject[`${start_end}_month`];
          const year = activeProject[`${start_end}_year`];
          if (month && year) return moment(`${year}-${month}`, 'YYYY-MMMM');
          return null;
        };
        const start_date = getDate('start');
        const end_date = getDate('end');
        if (moment(start_date.format('YYYY-MM-01')).isAfter(end_date.format('YYYY-MM-01'))) {
          if (updateErrorState) {
            this.setError('start_month');
            this.setError('start_year');
            this.setError('end_month');
            this.setError('end_year');
            valid = false;
          }
        } else {
          if (updateErrorState) {
            this.resetError('start_month');
            this.resetError('start_year');
            this.resetError('end_month');
            this.resetError('end_year');
          }
        }
      }

      if (!activeProject.skills || !activeProject.skills.length) {
        if (updateErrorState) this.setError('skills');
        valid = false;
      } else {
        if (updateErrorState) this.resetError('skills');
      }
      return valid;
    }

    onFilesUpdate = (files) => {
      this.set({ files });
    }

    onFilesDelete = (file) => {
      if (file.project_file_id) {
        if (this.state.activeProject.deletedFiles) {
          this.set({ deletedFiles: [...this.state.activeProject.deletedFiles, file] });
        } else {
          this.set({ deletedFiles: [file] });
        }
      }
    }

    onSkillsChange = (list) => {
      const { base_skills } = this.state;
      base_skills
        .filter(item => item.autoSelect && !list.includes(item.skill_id))
        .forEach(item => {
          item.autoSelect = false;
        });
      this.set({ skills: [...base_skills].filter((skill) => list.includes(skill.skill_id)) });
      this.resetError('skills');
    }

    closeModal = () => {
      const { activeProject } = this.state;
      if (activeProject && activeProject.$changed) {
        Modal.confirm({
          title: 'Cancel the changes?',
          content: 'Changes you made won\'t be saved',
          okType: 'primary',
          iconType: null,
          width: 400,
          okText: 'Ok',
          cancelText: 'Cancel',
          onOk: () => {
            this.setActiveProject(false);
          }
        });
      } else {
        this.setActiveProject(false);
      }
    }

    render () {
      const { item, passed_skills, skills_inprogress } = this.props;
      const { activeProject, skills, base_skills } = this.state;
      const skillIds = [...skills].map((skill) => +skill.skill_id);
      return (
        <div>
          <div className="Workhistory-form-projects-container">
            <div className="Workhistory-form-projects">
              {(item.projects || []).filter(project => !project.$deleted).map((project, i) => (
                <Project key={i} {...project} project={project} onEdit={this.setActiveProject} />
              ))}
              {(item.projects || []).filter(project => !project.$deleted).length
                ? null
                : (
                  <div className="Workhistory-form-project">
                    <div
                      className="Workhistory-form-new-project Workhistory-form-btn-add-project"
                      onClick={(e) => ref.current.addNewProject()}
                    >
                      <AddCircleOutlineIcon/>
                      <span>Add project</span>
                    </div>
                  </div>
                )}
            </div>
          </div>
          <CustomModal
            visible={!!activeProject}
            onClose={this.closeModal}
            help={<RightSidebar.AddProjectComponent />}
            title={ activeProject && activeProject.$newProject ? 'Add project' : 'Edit project' }
            description="Frontend Engineer at Acme Corporation"
          >
            {activeProject
              ? (
                <div>
                  <div>
                    <div className="grid-container">
                      <div className="c1">
                        <Input
                          placeholder="Project name"
                          {...this.bind('project_name')}
                        />
                      </div>
                      <div className="c2">
                        <Input
                          placeholder="URL or GitHub repo (optional)"
                          {...this.bind('url')}
                        />
                      </div>
                      <div className="c6">
                        <Input.Select
                          placeholder="Start month"
                          options={this.months}
                          {...this.bind('start_month')}
                        />
                      </div>
                      <div className="c7">
                        <Input.Select
                          placeholder="Start year"
                          options={this.years}
                          {...this.bind('start_year')}
                        />
                      </div>
                      <div className="c8">
                        <Input.Select
                          placeholder="End month"
                          options={this.months}
                          {...this.bind('end_month')}
                        />
                      </div>
                      <div className="c9">
                        <Input.Select
                          placeholder="End year"
                          options={this.years}
                          {...this.bind('end_year')}
                        />
                      </div>
                      <div className="c3">
                        <CustomModal.Highlight helpSectionOnly help={<RightSidebar.BuildComponent/>} onMobileShowButton="Show examples">
                          <div className="form-item-editor">
                            <Input.Editor height={160} placeholder="What did you build?" {...this.bind('details')} limit={65535} hideLimit />
                          </div>
                        </CustomModal.Highlight>
                      </div>
                      <div className="c4">
                        <CustomModal.Highlight helpSectionOnly help={<RightSidebar.OutcomeComponent/>} onMobileShowButton="Show examples">
                          <div>
                            <Input.Editor height={160} placeholder="What was the outcome of the project?" {...this.bind('outcome')}/>
                          </div>
                        </CustomModal.Highlight>
                      </div>
                      <div className="c5">
                        <SelectCustomSkills
                          key={this.state.skillsListKey}
                          errors={this.state.errors.skills}
                          activeProject={activeProject}
                          skillIds={skillIds}
                          onSkillsChange={this.onSkillsChange}
                          skills={skills}
                          skillRender={this.skillRender}
                          onSelect={this.onSelect}
                          base_skills={base_skills}
                          passed_skills={passed_skills}
                          skills_inprogress={skills_inprogress}
                        />
                      </div>
                    </div>
                    <div>
                      <br />
                      <b>Screenshots (optional)</b>
                      <UploadImage
                        project={activeProject}
                        onUpdate={this.onFilesUpdate}
                        onRemove={this.onFilesDelete}
                      />
                    </div>
                  </div>
                  <div className="project-modal-action left-div">
                    {activeProject.$newProject
                      ? null
                      : (
                        <Button type="danger" onClick={this.onDelete}>
                      Delete
                        </Button>
                      )}
                  </div>
                  <div className="project-modal-action right-div">
                    <Button onClick={this.closeModal}>
                    Cancel
                    </Button>
                    <Button type="primary" onClick={this.onSave}>
                    Save
                    </Button>
                  </div>
                </div>
              )
              : null}
          </CustomModal>
        </div>
      );
    }
  }

  ProjectsList.propTypes = Projects.propTypes;

  return <ProjectsList {...props} />;
}));

Projects.propTypes = {
  onEdit: PropTypes.func,
  onUpdate: PropTypes.func,
  item: PropTypes.any,
  skills: PropTypes.array,
  setContentId: PropTypes.func,
  base_skills: PropTypes.array,
  passed_skills: PropTypes.array,
  skills_inprogress: PropTypes.array
};

const Project = React.memo((props) => {
  const { project } = props;
  function unescapeHTML (html) {
    const escapeEl = document.createElement('div');
    escapeEl.innerHTML = html;
    return escapeEl.textContent;
  }
  return (
    <div className="Workhistory-form-project">
      <div className="Workhistory-form-project-head">
        <div className="title">{project.project_name}</div>
        <IconButton onClick={() => props.onEdit(project)}>
          <EditIcon />
        </IconButton>
      </div>
      <p>{unescapeHTML(project.details)}</p>
      <div className="project-tags">
        {project.skills.map((skill) => (
          <span key={skill.skill_id}>{skill.skill_name}</span>
        ))}
      </div>
      <div className="project-img-count">
        <PhotoLibraryIcon /> {project.files.length} screenshots
      </div>
    </div>
  );
});

Project.propTypes = {
  onEdit: PropTypes.func,
  project: PropTypes.any
};

function getBase64 (file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export class UploadImage extends React.PureComponent {
  constructor (props) {
    super();
    let files = [];
    if (props.project && props.project.files) {
      files = props.project.files.map(this.initFile);
    }
    this.state = {
      notAllowedFormats: [],
      previewVisible: false,
      previewImage: '',
      files
    };
  }

  async componentDidUpdate (prevProps) {
    if (prevProps.project !== this.props.project) {
      let arr1 = get(this.props, 'project.files', []);
      let arr2 = get(prevProps, 'project.files', []);
      arr1 = Array.isArray(arr1) ? arr1 : [];
      arr2 = Array.isArray(arr2) ? arr2 : [];
      try {
        const list1 = await Promise.all(arr1.map(this.getUrlOrPreview));
        const list2 = await Promise.all(arr2.map(this.getUrlOrPreview));
        if (list1.join('|') !== list2.join('|')) {
          this.setState({ files: this.props.project.files.map(this.initFile) });
        }
      } catch (error) {
        this.setState({ files: arr1.map(this.initFile) });
      }
    }
  }

  getUrlOrPreview = async (file) => {
    return file.originFileObj ? await getBase64(file.originFileObj) : `${getGCSUrl()}/portfolio/${file.name}`;
  }

  initFile = (file) => {
    return {
      ...file,
      url: file.originFileObj ? null : `${getGCSUrl()}/portfolio/${file.name}`
    };
  };

  handleCancel = () => this.setState({ previewVisible: false });

  handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true
    });
  };

  handleChange = ({ fileList }) => {
    const notAllowedFormats = [];
    fileList = fileList.filter(file => {
      if (!['image/apng', 'image/bmp', 'image/png', 'image/gif', 'image/jpeg'].includes(`${file.type}`.toLowerCase())) {
        if (!notAllowedFormats.includes(file.type)) notAllowedFormats.push(file.type);
        return false;
      }
      return true;
    });
    this.setState({ files: fileList.map(this.initFile), notAllowedFormats });
    if (this.props.onUpdate) {
      this.props.onUpdate(fileList.map(this.initFile));
    }
  };

  uploadButton = () => {
    return (
      <div>
        <AddIcon />
        <div style={{ marginTop: 8 }}>Upload</div>
      </div>
    );
  };

  render () {
    const { previewVisible, previewImage, files, notAllowedFormats } = this.state;
    return (
      <div style={{ margin: '15px 0' }}>
        <Upload
          listType="picture-card"
          fileList={files}
          accept="image/apng, image/bmp, image/png, image/gif, image/jpeg"
          onPreview={this.handlePreview}
          onChange={this.handleChange}
          beforeUpload={() => false}
          onRemove={this.props.onRemove}
          multiple
        >
          {this.uploadButton()}
        </Upload>
        <Modal
          visible={previewVisible}
          footer={null}
          onCancel={this.handleCancel}
        >
          <img alt="example" style={{ width: '100%' }} src={previewImage} />
        </Modal>
        <Modal
          visible={notAllowedFormats && Array.isArray(notAllowedFormats) && notAllowedFormats.length}
          footer={null}
          onCancel={() => this.setState({ notAllowedFormats: [] })}
        >
          <p>Sorry, this file type is not permitted for security reasons</p>
          <p>{notAllowedFormats.join(', ')}</p>
        </Modal>
      </div>
    );
  }
}

UploadImage.propTypes = {
  project: PropTypes.any,
  onUpdate: PropTypes.func,
  onRemove: PropTypes.func
};

const WorkhistorySection = React.forwardRef((props, ref) => <Workhistory {...props} _ref={ref} />);
export default WorkhistorySection;
